/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./IconMacro.vue?vue&type=template&id=67842c2d"
import script from "./IconMacro.vue?vue&type=script&lang=js"
export * from "./IconMacro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67842c2d')) {
      api.createRecord('67842c2d', component.options)
    } else {
      api.reload('67842c2d', component.options)
    }
    module.hot.accept("./IconMacro.vue?vue&type=template&id=67842c2d", function () {
      api.rerender('67842c2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon/IconMacro.vue"
export default component.exports